import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { cn } from "@/shared/lib/cn";
import { IconButton } from "@/shared/ui";
import { useOnlineStatus } from "@/offline";
import { useInAppNotificationsQuery } from "@/modules/sys/queries/useSysQueries";

const BELL_POLL_MS = 45_000;

/** Header bell → inbox với badge chưa đọc (Field hoặc EXE). */
export function FieldNotifyBellButton({
  to = "/field/notifications",
  from,
}: {
  to?: string;
  from?: string;
}) {
  const navigate = useNavigate();
  const online = useOnlineStatus();
  const list = useInAppNotificationsQuery({
    take: 50,
    refetchIntervalMs: online ? BELL_POLL_MS : false,
  });
  const unread = useMemo(
    () => (list.data ?? []).filter((n) => !n.isRead).length,
    [list.data],
  );

  return (
    <span className="relative inline-flex">
      <IconButton
        tooltip={false}
        label={unread > 0 ? `Thông báo · ${unread} chưa đọc` : "Thông báo"}
        icon={<Bell />}
        size="touch"
        onClick={() =>
          navigate(to, from ? { state: { from } } : undefined)
        }
      />
      {unread > 0 ? (
        <span
          className={cn(
            "pointer-events-none absolute top-0.5 right-0.5 flex h-4 items-center justify-center rounded-full bg-danger font-extrabold leading-none text-white ring-2 ring-primary shadow-xs font-[family-name:var(--font-badge)] tabular-nums",
            unread < 10
              ? "w-4 text-[10.5px]"
              : "min-w-4 px-1 text-[9.5px] tracking-tight",
          )}
          aria-hidden
        >
          {unread > 99 ? "+99" : unread}
        </span>
      ) : null}
    </span>
  );
}
